import { Button, Grid, IconButton, Zoom } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Dropzone from "react-dropzone";
import { getEmergencySetting, updateEmergencySetting } from "../../../../api/emergencySettingApi";
import { uploadImageFile } from "../../../../api/uploadApi";
import { useForceRender } from "../../../../utils/customHook";
import { toImageUrl } from "../../../../utils/formatHelper";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { useStyleEmerSetting } from "./helpers/emerSettingEvtOption";
import { useSelector } from "react-redux";
import { swalCondition } from "../../../../utils/swalHelper";

export default function EmergencySetting() {
    const classes = useStyleEmerSetting();
    const [render, forceRender] = useForceRender();

    // ref
    const controllerRef = useRef(null);

    // global redux state
    const { thisMenuPermission } = useSelector(state => {
        const { menuPermission } = state?.menu;
        return {
            thisMenuPermission: menuPermission?.find(menu => menu?.path === window.location.pathname)?.permission,
        };
    });

    // conponent state
    const [stateFile, setStateFile] = useState(null);

    const addFilesImage = useCallback(
        async file => {
            setStateFile(null);
            const reader = new FileReader();
            reader.readAsDataURL(file[0]);
            reader.onload = async evt => {
                setStateFile(currentState => ({
                    ...currentState,
                    name: file[0]?.name,
                    src: evt?.target?.result,
                }));
            };
            setStateFile(currentState => ({
                ...currentState,
                name: file[0]?.name,
                file: file[0],
            }));
        },
        [setStateFile],
    );

    const handleSaveEmergencySetting = useCallback(async () => {
        try {
            // upload image
            let imagePath = stateFile?.imagePath;
            if (stateFile?.file) {
                const formData = new FormData();
                formData.append("image", stateFile?.file);
                imagePath = await uploadImageFile(formData, controllerRef.current?.signal);
            }

            const isUpdate = await updateEmergencySetting({ image: imagePath }, controllerRef.current?.signal);
            if (isUpdate) {
                swalCondition("สำเร็จ", "บันทึกข้อมูลเรียบร้อย", {
                    icon: "success",
                    showCancelButton: false,
                    confirmButtonText: "OK",
                });
                forceRender();
            }
        } catch (error) {
            console.dir(error);
        }
    }, [stateFile, forceRender]);

    const handleCancel = useCallback(() => {
        setStateFile(null);
        forceRender();
    }, [forceRender]);

    const removeFile = useCallback(() => {
        setStateFile(null);
    }, []);

    // run only first render
    useEffect(() => {
        controllerRef.current = new AbortController();
        const init = async () => {
            try {
                const res = await getEmergencySetting(controllerRef.current?.signal);
                if (res) {
                    setStateFile(
                        res?.image
                            ? {
                                  name: "",
                                  src: toImageUrl(res?.image),
                                  imagePath: res?.image,
                              }
                            : null,
                    );
                }
            } catch (error) {
                console.dir(error);
            }
        };
        init();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
    }, [render]);

    return (
        <Grid container spacing={0}>
            <Grid item xs={12} className="mb-5 mb-sm-10">
                <h1 className="t-text-primary">Emergency Setting</h1>
            </Grid>

            {/* content */}
            <Grid item xs={12}>
                <Grid container spacing={0}>
                    {thisMenuPermission?.create && thisMenuPermission?.edit && (
                        <Grid item xs={12}>
                            <Dropzone onDrop={addFilesImage} maxFiles={1} multiple={false} accept={{ "image/*": [] }}>
                                {({ getRootProps, getInputProps }) => (
                                    <div>
                                        <input {...getInputProps()} />
                                        <div className="row justify-content-center align-items-center">
                                            <div className="col-7 col-md-4">
                                                <div
                                                    {...getRootProps()}
                                                    className={`border rounded px-5 mt-6 ${classes.textShowImage} `}>
                                                    {stateFile !== null ? stateFile?.name : ""}
                                                </div>
                                            </div>
                                            <div className="col-5 col-md-2">
                                                <p className="mb-0">
                                                    Image <span className="text-danger">(720 x 300)</span>
                                                </p>
                                                <Button
                                                    className={`t-btn-primary w-100 ${classes.btnUpload}`}
                                                    {...getRootProps()}>
                                                    Upload
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </Dropzone>
                        </Grid>
                    )}

                    {/* preview */}
                    <Grid item xs={12} className="mt-10">
                        {stateFile !== null ? (
                            <Zoom in={true}>
                                <div className="row justify-content-center align-items-center">
                                    <div className="col-11 col-sm-6 col-xl-6">
                                        <div className="border position-relative">
                                            <IconButton
                                                onClick={removeFile}
                                                className="position-absolute top-0 right-0">
                                                <Close className="text-danger" />
                                            </IconButton>
                                            <img
                                                src={stateFile?.src}
                                                className="img-fluid w-100"
                                                alt={stateFile.name}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Zoom>
                        ) : (
                            <Zoom in={true}>
                                <div className="row justify-content-center align-items-center">
                                    <div className="col-11 col-sm-6 col-xl-6">
                                        <div className="border position-relative">
                                            <img
                                                src={toAbsoluteUrl("/media/HCH/imgs/no-image-lg.png")}
                                                className="img-fluid w-100"
                                                alt={"noimage"}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Zoom>
                        )}
                    </Grid>

                    {/* actions */}
                    {thisMenuPermission?.create && thisMenuPermission?.edit && (
                        <Grid item xs={12} className="mt-10">
                            <div className="row justify-content-center align-items-center">
                                <div className="col-11 col-sm-6 col-xl-6">
                                    <div className="row justify-content-md-end">
                                        <div className="col-6 col-md-4 col-lg-2 mr-2">
                                            <Button
                                                className="t-btn-primary w-100"
                                                onClick={handleSaveEmergencySetting}>
                                                Save
                                            </Button>
                                        </div>
                                        <div className="col-6 col-md-4 col-lg-2" onClick={handleCancel}>
                                            <Button className="t-btn-gray w-100">Cancel</Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
}
